import React from 'react'
import cls from 'classnames'

import classes from './AccountList.module.scss'

export default function List(props) {
	return (
		<ul
			className={cls('list-group', classes.AccountList, props.listClassName)}
		>
			{props.accountList.map((account, i) => {
				return (
					<li
						key={i}
						className={cls({
							'list-group-item': true,
							'list-group-item-danger': account.country === 'CA' && !account.isVisited,
							'list-group-item-warning': account.country === 'DE' && !account.isVisited,
							'list-group-item-primary': account.country === 'RU' && !account.isVisited,
							[classes.AccountList__item]: true,
							[classes.AccountList__item_visited]: account.isVisited
						})}
					>
						<a
							href={account.url}
							className={cls({
								[classes.AccountList__link_visited]: account.isVisited
							})}
							target='_blank'
							rel='noopener noreferrer'
							onClick={event => props.onLinkClick(event.currentTarget.getAttribute('href'))}
						>
							{account.username}
						</a>
						<span>
							{account.country}
						</span>
					</li>
				)
			})}
		</ul>
	)
}